import { getPdfSizes } from "helpers";
import { t } from "i18next";
import jsPDF from "jspdf";
import moment from "moment";

import { OrderDetails } from "../../orders.types";

interface renderTitlesProps {
  pdf: jsPDF;
  bigFontSize: number;
  normalFontSize: number;
  orderDetails: OrderDetails;
}

export const renderTitles = ({
  pdf,
  bigFontSize,
  normalFontSize,
  orderDetails
}: renderTitlesProps) => {
  const { pageWidth } = getPdfSizes(pdf);

  if (orderDetails.isExpedition) {
    const previousFillColor = pdf.getFillColor();
    const previousTextColor = pdf.getTextColor();

    const label = t("EXPEDITION");
    const badgePaddingX = 6;
    const badgeHeight = 14;
    const badgeMargin = 16;

    pdf.setFontSize(8).setFont("NotoSans", "bold");
    const textWidth = pdf.getTextWidth(label);
    const badgeWidth = textWidth + badgePaddingX * 2;
    const badgeX = pageWidth - badgeMargin - badgeWidth;
    const badgeY = 14;

    pdf.setFillColor(122, 77, 255);
    pdf.roundedRect(badgeX, badgeY, badgeWidth, badgeHeight, 3, 3, "F");

    pdf
      .setTextColor(255, 255, 255)
      .text(label, badgeX + badgeWidth / 2, badgeY + badgeHeight / 2 + 2.8, {
        align: "center"
      });

    pdf.setTextColor(previousTextColor);
    pdf.setFillColor(previousFillColor);
  }

  pdf
    .setFontSize(bigFontSize)
    .setFont("NotoSans", "bold")
    .text(`${t("Order")} #${orderDetails.id}`, pageWidth / 2, 36, {
      align: "center"
    });

  pdf.setFontSize(normalFontSize);
  pdf.text(
    `${t("Order Placed")}: ${moment(
      orderDetails?.createdAt ?? orderDetails.createdAt
    ).format("DD MMMM, YYYY")}`,
    pageWidth / 2,
    51,
    {
      align: "center"
    }
  );

  const orderTotal = orderDetails?.totalOrder ?? orderDetails.totalOrder;

  pdf.text(
    `${t("Order Total")}: ${orderTotal?.toLocaleString("en-US")} FCFA`,
    pageWidth / 2,
    64,
    { align: "center" }
  );
};
